import { useState } from 'react';
import { Job } from '../../menu/jobsMenu/types';

export const useBatchExportJob = () => {
  const [isExportInProgress, setIsExportInProgress] = useState(false);
  const [jobId, setJobId] = useState<string | null>(null);

  const onJobComplete = () => {
    setIsExportInProgress(false);
  };

  const onExportStart = () => {
    setJobId(null);
    setIsExportInProgress(true);
  };

  const onAddJobSuccess = (job: Job) => {
    setJobId(job.jobId);
  };

  const onAddJobError = () => {
    setIsExportInProgress(false);
  };

  return {
    onExportStart,
    onAddJobSuccess,
    onJobComplete,
    onAddJobError,
    isExportInProgress,
    jobId,
  };
};


